import { FlexContainer } from '@act/storybook';
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface ReportFormFieldProps {
  label: string;
  children: ReactNode;
}

/**
 * Labeled field wrapper for report create/edit metadata forms.
 * @param label - Field label shown above the control.
 * @param children - Input control.
 * @returns Styled form field column.
 */
const ReportFormField = ({ label, children }: ReportFormFieldProps) => (
  <FlexContainer
    direction="column"
    gap={0.5}
    width="100%"
    height="auto"
    overflowAllVisible={true}
  >
    <Typography variant="subtitle2">{label}</Typography>
    {children}
  </FlexContainer>
);

export default ReportFormField;
